import { useCallback, useRef, useState } from "react"

/**
 * Расширение хука `useState`, которое сохраняет предыдущее значение состояния при его изменении.
 * @param initValue
 * @hook
 * @category Hook
 */
export function useCachedState<C>(initValue: C) {
	const [value, setValue] = useState(initValue)
	const cachedValue = useRef(initValue)
	const changeValue = useCallback(
		(newValue: C) =>
			setValue((curValue: C) => {
				cachedValue.current = curValue
				return newValue
			}),
		[],
	)

	return [value, cachedValue.current, changeValue] as const
}
